module.exports = __webpack_public_path__ + "static/media/plus.9a718812.png";